"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.regexEscape = regexEscape;
exports.exact = exact;
exports.regexLength = regexLength;
exports.getContextAgnosticMap = void 0;

var _regex = require("./regex");

const asciis = Array.from({
  length: 0x80
}, (_, i) => String.fromCodePoint(i));

const getChars = flags => {
  // delete 'i' as it doesn't affect escaping and messes up matching logic
  const flagSet = new Set(flags);
  flagSet.delete('i');
  flags = [...flagSet].join('');
  return asciis.map(ch => {
    const escaped = `\\x${ch.codePointAt(0).toString(16).padStart(2, '0')}`;
    let inClass = escaped;
    let outsideClass = escaped;
    let agnostic = escaped;

    try {
      const inClassRe = new RegExp(`[${ch}]`, flags);
      new RegExp(`[${ch}${ch}]`, flags);
      new RegExp(`[${ch}${ch}\0]`, flags);

      if (inClassRe.test(ch) && !asciis.filter(x => x !== ch).some(x => inClassRe.test(x))) {
        inClass = ch;
      } else {
        new RegExp(`[\\${ch}]`, flags);
        inClass = `\\${ch}`;
      }
    } catch (_a) {
      try {
        new RegExp(`[\\${ch}]`, flags);
        inClass = `\\${ch}`;
      } catch (_b) {}
    }

    try {
      const outsideClassRe = new RegExp(`^${ch}$`, flags);

      if (outsideClassRe.test(ch) && !asciis.filter(x => x !== ch).some(x => outsideClassRe.test(x))) {
        outsideClass = ch;
      } else {
        new RegExp(`\\${ch}`, flags);
        outsideClass = `\\${ch}`;
      }
    } catch (_c) {
      try {
        new RegExp(`\\${ch}`, flags);
        outsideClass = `\\${ch}`;
      } catch (_d) {}
    }

    if (inClass !== outsideClass) {
      try {
        new RegExp(`\\${ch}`, flags);
        new RegExp(`\\${ch}`, flags);
        agnostic = `\\${ch}`;
      } catch (_e) {}
    } else {
      agnostic = [inClass, outsideClass].sort((a, b) => b.length - a.length)[0];
    }

    return {
      ch,
      agnostic,
      inClass,
      outsideClass
    };
  }).filter(x => x.inClass !== x.ch || x.outsideClass !== x.ch);
};

const cache = new Map();

const getContextAgnosticMap = flags => {
  const cached = cache.get(flags);

  if (cached) {
    return cached;
  }

  const obj = Object.fromEntries(getChars(flags).map(x => [x.ch, x.agnostic]));
  cache.set(flags, obj);
  return obj;
};

exports.getContextAgnosticMap = getContextAgnosticMap;

function regexEscape(input, flags = 'u') {
  const contextAgnosticMap = getContextAgnosticMap(flags);
  const chars = Object.values(contextAgnosticMap);

  const replacer = str => str.replace(new RegExp(`[${chars.join('')}]`, [...new Set([...flags, ...'g'])].join('')), m => contextAgnosticMap[m]);

  return new _regex.RegexFragment(replacer(input));
}

function exact(input, flags) {
  return (0, _regex.regex)(flags)`${input}`;
}
/**
 * Gives approximate logical "length" of a string, regex, or regex fragment, for
 * use in sorting arrays to be used in alternation groups. Doesn't cover various
 * edge cases or variable-length regexes (e.g. /a+/, /b{1,5}/, etc).
 */


function regexLength(input) {
  return (// TODO?
    // .replace(/\[[^\]]+\]/g, '.')
    input // TODO?
    // .replace(/(?<=[^\\](\\{2})*)\\b|[^$]/g, '')
    .replace(/\\(?:\w\{[^}]+\}|u[0-9a-f]{4}|x[0-9a-f]{2}|[0-8]{3}|c[A-Z]|.)/gi, '.').length
  );
} // TODO?
// export function regexUnescape(input: RegexFragment | string) {
// 	return input.replace(/s/g)
// }